<!-- @format -->

@if (colors && colors.length) {
	<div class="swatches hmf-display-flex hmf-align-items-center">
		@for (
			color of colors | slice: 0 : maxColorSwatchesToShow;
			track trackBySwatch($index, color)
		) {
			<homefield-color-swatch
				class="hmf-m-xxxs"
				radius="50%"
				height="21px"
				width="21px"
				[color]="color"
				[imageSrc]="getImageSource(color)"
				[colorSwatchHoverDimension]="true"
				[selected]="selectedSwatchColor === color"
				(mouseover)="setImageColor(color)"
				(colorSwatchError)="
					handleImageError({ requestedImg: $event, color: color })
				"></homefield-color-swatch>
		}

		@if (colors.length > maxColorSwatchesToShow) {
			<button
				homefield-text-link
				class="hmf-m-xxxs"
				[ariaLabel]="moreColorsButtonAriaLabel"
				[linkURL]="assetSeoUrl"
				[styled]="true"
				(click)="extraColorsClicked()">
				{{ colors.length - maxColorSwatchesToShow }}+
			</button>
		}
	</div>
}
